export type MenuLinkGroup =
  | 'Админка'
  | 'Продажи'
  | 'Колл-центр'
  | 'Планирование'
  | 'Логистика'
  | 'HR'
  | 'Документы'
  | 'Отчёты'
  | 'Прочее'
  | 'Рекламации'
  | 'Дилеры'

export type MenuLink = {
  key: string
  url: string
  title: string
  group: MenuLinkGroup
  defaultIcon?: string
}

const LINKS: MenuLink[] = [
  {
    key: 'home',
    url: '/home',
    title: 'Главная',
    group: 'Прочее',
    defaultIcon: 'HomeOutlined',
  },
  {
    key: 'admin',
    url: '/admin',
    title: 'Админка',
    group: 'Админка',
    defaultIcon: 'SettingOutlined',
  },
  {
    key: 'adminMenuEditor',
    url: '/admin/menu-editor',
    title: 'Редактор меню',
    group: 'Админка',
    defaultIcon: 'SettingOutlined',
  },
  {
    key: 'adminDealersDomains',
    url: '/admin/dealers/domains',
    title: 'Поддомены дилеров',
    group: 'Дилеры',
    defaultIcon: 'GlobalOutlined',
  },
  {
    key: 'adminDealersModules',
    url: '/admin/dealers/modules',
    title: 'Модули',
    group: 'Дилеры',
    defaultIcon: 'AppstoreOutlined',
  },
  {
    key: 'adminDealersSettings',
    url: '/admin/dealers/settings',
    title: 'Настройки',
    group: 'Дилеры',
    defaultIcon: 'SettingOutlined',
  },
  {
    key: 'adminDealersPolls',
    url: '/admin/dealers/polls',
    title: 'Управление опросами',
    group: 'Дилеры',
    defaultIcon: 'FormOutlined',
  },
  {
    key: 'personnel',
    url: '/personnel',
    title: 'Сотрудники',
    group: 'Админка',
    defaultIcon: 'TeamOutlined',
  },
  {
    key: 'adminRoles',
    url: '/admin/roles',
    title: 'Роли',
    group: 'Админка',
    defaultIcon: 'UserOutlined',
  },
  {
    key: 'adminFields',
    url: '/admin/fields',
    title: 'Поля',
    group: 'Админка',
    defaultIcon: 'ToolOutlined',
  },
  {
    key: 'adminFieldGroups',
    url: '/admin/field-groups',
    title: 'Группы полей',
    group: 'Админка',
    defaultIcon: 'ToolOutlined',
  },
  {
    key: 'adminOrderStagePlan',
    url: '/admin/order-stage-plan',
    title: 'План стадий заказа',
    group: 'Админка',
    defaultIcon: 'SettingOutlined',
  },
  {
    key: 'adminClaimStagePlan',
    url: '/admin/claim-stage-plan',
    title: 'План стадий рекламации',
    group: 'Админка',
    defaultIcon: 'SettingOutlined',
  },
  {
    key: 'adminEmailMonitor',
    url: '/admin/email-monitor',
    title: 'Email монитор',
    group: 'Админка',
    defaultIcon: 'MailOutlined',
  },
  {
    key: 'adminEnumCollections',
    url: '/admin/enum-collections',
    title: 'Редактор коллекций',
    group: 'Админка',
    defaultIcon: 'ToolOutlined',
  },

  {
    key: 'appeals',
    url: '/appeals',
    title: 'Обращения',
    group: 'Продажи',
    defaultIcon: 'PhoneOutlined',
  },
  {
    key: 'orders',
    url: '/orders',
    title: 'Заказы',
    group: 'Продажи',
    defaultIcon: 'DollarOutlined',
  },
  {
    key: 'measurements',
    url: '/measurements',
    title: 'Замеры',
    group: 'Продажи',
    defaultIcon: 'AreaChartOutlined',
  },
  {
    key: 'montage',
    url: '/montage',
    title: 'Монтаж',
    group: 'Продажи',
    defaultIcon: 'ToolOutlined',
  },
  {
    key: 'clients',
    url: '/call-center/new-clients',
    title: 'Клиенты',
    group: 'Продажи',
    defaultIcon: 'UserOutlined',
  },

  {
    key: 'tasks',
    url: '/tasks',
    title: 'Задачи',
    group: 'Планирование',
    defaultIcon: 'FormatPainterOutlined',
  },
  {
    key: 'tasksCalendar',
    url: '/tasks/calendar',
    title: 'Календарь задач',
    group: 'Планирование',
    defaultIcon: 'HistoryOutlined',
  },

  {
    key: 'logisticsDashboard',
    url: '/logistic-dashboard',
    title: 'Дашборд',
    group: 'Логистика',
  },
  {
    key: 'logisticsDeliveries',
    url: '/logistics/deliveries',
    title: 'Доставки',
    group: 'Логистика',
  },
  {
    key: 'logisticsDeliveries',
    url: '/admin/collections/delivery-prices-zones/objects',
    title: 'Территории',
    group: 'Логистика',
  },
  {
    key: 'logisticsRouteSheets',
    url: '/logistics/route-sheets',
    title: 'Маршрутные листы',
    group: 'Логистика',
    defaultIcon: 'CarOutlined',
  },

  { key: 'hr', url: '/hr', title: 'HR', group: 'HR', defaultIcon: 'HeartOutlined' },
  {
    key: 'hrDashboard',
    url: '/hr/dashboard',
    title: 'HR дашборд',
    group: 'HR',
    defaultIcon: 'BarChartOutlined',
  },
  {
    key: 'hrEmployees',
    url: '/hr-employees',
    title: 'Сотрудники',
    group: 'HR',
    defaultIcon: 'UserOutlined',
  },
  {
    key: 'hrDashboards',
    url: '/hr/dashboards',
    title: 'Дашборды',
    group: 'HR',
  },
  {
    key: 'hrFeedbackFunnel',
    url: '/hr/feedback-funnel',
    title: 'Динамика действий по месяцам',
    group: 'HR',
  },

  {
    key: 'documentTemplates',
    url: '/document-templates',
    title: 'Шаблоны документов',
    group: 'Документы',
    defaultIcon: 'FileExclamationOutlined',
  },

  {
    key: 'powerbiReport',
    url: '/powerbi-report',
    title: 'Power BI отчёт',
    group: 'Отчёты',
    defaultIcon: 'IconPowerBI',
  },
  {
    key: 'reportsSalesContracts',
    url: '/reports-sales-contracts',
    title: 'Отчет по заказам',
    group: 'Отчёты',
    defaultIcon: 'BarChartOutlined',
  },
  {
    key: 'aiReports',
    url: '/ai/reports',
    title: 'Отчеты ИИ',
    group: 'Отчёты',
    defaultIcon: 'BarChartOutlined',
  },
  {
    key: 'integrations',
    url: '/ai/integrations',
    title: 'Интеграции',
    group: 'Прочее',
    defaultIcon: 'ApartmentOutlined',
  },

  {
    key: 'claimsRequests',
    url: '/claims-requests',
    title: 'Заявки на рекламацию',
    group: 'Рекламации',
    defaultIcon: 'FileExclamationOutlined',
  },
  {
    key: 'claims',
    url: '/claims',
    title: 'Рекламации',
    group: 'Рекламации',
    defaultIcon: 'HistoryOutlined',
  },
  {
    key: 'claimsWorks',
    url: '/claims-works',
    title: 'Работы по рекламациям',
    group: 'Рекламации',
    defaultIcon: 'ToolOutlined',
  },

  {
    key: 'organizations',
    url: '/new/organizations',
    title: 'Организации',
    group: 'Прочее',
    defaultIcon: 'BankOutlined',
  },
  {
    key: 'callCenterTelephony',
    url: '/call-center-telephony',
    title: 'Телефония',
    group: 'Прочее',
    defaultIcon: 'PhoneOutlined',
  },
]

export function normalizeMenuUrl(input?: string): string {
  const raw = (input ?? '').trim()
  if (!raw) return ''
  return raw.startsWith('/') ? raw : `/${raw}`
}

/** When platform-admin is deployed, hide ERP «Дилеры» (control-plane moved to base). */
function isControlPlaneExternal(): boolean {
  return Boolean(String(process.env.REACT_APP_PLATFORM_ADMIN_HOST || '').trim())
}

/** Пункты меню, доступные всегда, независимо от allowed_menu_keys тенанта. */
export const ALWAYS_ALLOWED_MENU_KEYS = ['home']

export function getMenuLinksCatalog(allowedKeys?: string[] | null): MenuLink[] {
  let links = LINKS
  if (isControlPlaneExternal()) {
    links = links.filter(item => item.group !== 'Дилеры')
  }
  if (allowedKeys == null) return links
  const allowed = new Set([...ALWAYS_ALLOWED_MENU_KEYS, ...allowedKeys])
  return links.filter(item => allowed.has(item.key))
}

export function isAllowedMenuUrl(url?: string, allowedKeys?: string[] | null): boolean {
  const normalized = normalizeMenuUrl(url)
  if (!normalized) return false
  return getMenuLinksCatalog(allowedKeys).some(l => l.url === normalized)
}

export function getMenuLinkByUrl(url?: string): MenuLink | undefined {
  const normalized = normalizeMenuUrl(url)
  return LINKS.find(l => l.url === normalized)
}
